import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container, Button } from 'semantic-ui-react';
import {_InfoWidget} from '@deck.gl/widgets';
import '../styles/EscaypeHeatMap.css';
import {DeckGL} from '@deck.gl/react';
import {APIProvider, Map} from '@vis.gl/react-google-maps';
import {HeatmapLayer} from '@deck.gl/aggregation-layers';

function getHeatMapRadius(zoom) {
  /* 
  7 => 80,
  8 => 160
  9 => 320
  10 => 640*/

  return 80 * Math.pow(2, zoom - 7);
}

function getHeatmapParams(skunkEnabled, potentialEnabled) {
  if (skunkEnabled && potentialEnabled) {
    return {
      weightKey: 'compositeInterpolatedScore',
      colorRange: [[158, 46, 207, 35], [158, 46, 207, 180]]
    };
  } else if (skunkEnabled) {
    return {
      weightKey: 'skunk',
      colorRange: [[74, 207, 239, 35], [74, 207, 239, 180]]
    };
  } else { // if potentialEnabled
    return {
      weightKey: 'potential',
      colorRange: [[255, 156, 191, 35], [255, 156, 191, 180]]
    };
  }
}

class EscaypeHeatMap extends Component {
  constructor(props) {
    super(props);

    this.state = {
      potentialActive: true,
      skunkActive: true,
      viewState: {
        longitude: -122.419416,
        latitude: 37.774929,
        zoom: 7,
        maxZoom: 9,
        pitch: 0,
        bearing: 0
      }
    };
  }

  componentDidUpdate(prevProps) {
    // Check if marker position changed
    const { markerInfoWindowData } = this.props;
    const prevMarkerData = prevProps.markerInfoWindowData;
    
    if (markerInfoWindowData && 
        (!prevMarkerData || 
         markerInfoWindowData.obsLat !== prevMarkerData.obsLat || 
         markerInfoWindowData.obsLon !== prevMarkerData.obsLon)) {
      // Recenter the map on the new marker position
      this.setState({
        viewState: {
          ...this.state.viewState,
          longitude: markerInfoWindowData.obsLon,
          latitude: markerInfoWindowData.obsLat
        }
      });
    }
  }

  mapClicked = (info, event) => {
    // DeckGL click handler - info.coordinate is [lng, lat]
    if (info.coordinate) {
      const [lng, lat] = info.coordinate;
      this.props.onMarkerPositionChanged({lat, lng});
    }
  }

  render() {

    const { potentialActive, skunkActive, viewState } = this.state;

     let layers = [];
 
     if (potentialActive || skunkActive) {
       const heatmapParams = getHeatmapParams(skunkActive, potentialActive);
 
       console.log('!!!!!!!!!!!!!!');
       console.log(this.props.heatMapData);
       
       layers.push(
         new HeatmapLayer({
           data: this.props.heatMapData,
           id: 'heatmap-layer',
           pickable: false,
           getPosition: d => [d.obsLons, d.obsLats],
           getWeight: d => d[heatmapParams.weightKey],
           radiusPixels: getHeatMapRadius(viewState.zoom),
           intensity: 1,
           threshold: 0.03,
           colorRange: heatmapParams.colorRange
         }
       ));
     }

     const { markerInfoWindowData } = this.props;
     let infoWidgets = [];
     if (markerInfoWindowData) {
      infoWidgets.push(new _InfoWidget({
        visible: true,
        mode: 'static',
        position: [markerInfoWindowData.obsLon, markerInfoWindowData.obsLat],
        text: `${markerInfoWindowData.city}\nPotential: ${markerInfoWindowData.potential}, Skunk: ${markerInfoWindowData.skunk}`,
        style: {color: 'black', backgroundColor: 'white', fontSize: 'small', width: '100px', whiteSpace: 'pre-wrap'}
      }));
     }

    return (
      <div style={{display: 'flex', flexDirection: 'column', height: '100%', width: '100%'}}>
        <Container text style={{margin: '1rem auto 0 auto', right: '0px', left: '0px', position: 'absolute', zIndex: 1}}>
          <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
            <Button toggle active={potentialActive} attached='left' className='potential-button' style={{width: '50%', textAlign: 'center', flex: '1'}}
              onClick={() => this.setState({potentialActive: !potentialActive})}>Potential</Button>
            <Button toggle active={skunkActive} attached='right' className='skunk-button' style={{width: '50%', textAlign: 'center', flex: '1'}}
              onClick={() => this.setState({skunkActive: !skunkActive})}>Skunk</Button>
          </div>
        </Container>
        <div style={{flex: 1, width: '100%', height: 'calc(100vh - 180px)', position: 'relative'}}>
          <APIProvider apiKey="AIzaSyBvTyJVe_BpeXHzqilsM1Mp2nyJyGFvavE">
            <DeckGL 
              viewState={viewState} 
              controller={true}
              onViewStateChange={({viewState}) => this.setState({viewState})}
              onClick={this.mapClicked}
              layers={layers} 
              widgets={infoWidgets}
              style={{width: '100%', height: '100%'}}
            >
              <Map />
            </DeckGL>
          </APIProvider>
        </div>
      </div>
    );
  }
}

EscaypeHeatMap.propTypes = {
  google: PropTypes.any,
  map: PropTypes.any,

  heatMapData: PropTypes.arrayOf(PropTypes.shape({
    compositeInterpolatedScore: PropTypes.number.isRequired,
    obsLats: PropTypes.number.isRequired,
    obsLons: PropTypes.number.isRequired,
    potential: PropTypes.number.isRequired,
    skunk: PropTypes.number.isRequired
  })).isRequired,
  markerInfoWindowData: PropTypes.shape({
    city: PropTypes.string.isRequired,
    obsLat: PropTypes.number.isRequired,
    obsLon: PropTypes.number.isRequired,
    potential: PropTypes.number.isRequired,
    skunk: PropTypes.number.isRequired
  }),
  onMarkerPositionChanged: PropTypes.func.isRequired
};

export default EscaypeHeatMap;